import React, { useState } from 'react';
import {
  Card, Col, Row, Select
} from 'antd';

const IconImg = (props) => (
  <img src={props.name} alt="Services" />
)

const { Option } = Select;
const ProductCatalogComponent = ({ content }) => {
  return (
    <>
      <Row>
        {content.map(item => {
          return (
            <>
              <Col span={12} style={{ padding: 6 }}>{item.title}</Col>
              <Col span={4} offset={8} className="fw500" style={{ padding: 6 }}>{item.value}</Col>
            </>
          )
        })}
      </Row>
    </>
  )
};

export default function CardComponent(props) {

  const [dropDownClincValue, setDropDownClincValue] = useState('Medical Equipment');
  let dropdownValue = props.data.filter(data => data.title === dropDownClincValue)

  const cardClinicTitle = (
    <Row className="card-title">
      <Col span={4} className="icon-bg">
        <div><IconImg name={props.OrdersIcon} /></div>
      </Col>
      <Col style={{ paddingLeft: '30px' }}>
        <Col span={20} >
          <span className='select-button'>
            <Select defaultValue="Medical Equipment" onChange={(value) => setDropDownClincValue(value)}>
              {(props.data || []).map((val) => 
                <Option value={val.title} key={val.title}>{val.title}</Option>
              )}
            </Select>
          </span>
        </Col>
        <Col><p style={{ color: '#7F7F7F', fontSize: '13px' }}>Product catalog/Services</p></Col>
        <Col span={20} >
          <>
            {dropdownValue  && (
              <span>{dropdownValue && dropdownValue[0].total_count}</span>
            )}
          </>
        </Col>
      </Col>
    </Row>
  )

  return (
    props.data ? (
      <Card
        bordered={false}
        title={cardClinicTitle}
        className='dashboard-card'
      //extra={clinicDropdown}
      >
        {dropdownValue  && (
          <>
            <ProductCatalogComponent content={dropdownValue && dropdownValue[0].product_catalog} />
          </>
        )}
      </Card>
    ) : null
  );
}
